import React, { useState } from 'react';
import Sidebar from './Sidebar';
import '../styles/Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      <main className="main-content">
        <div className="mobile-header">
          <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)}>
            <span>☰</span>
          </button>
          <img src="/logo.png" alt="Montreal Kosher" className="mobile-logo" />
        </div>
        {children}
      </main>
    </div>
  );
};

export default Layout;
